/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Defines the object types in the model objects.  Each object type is the model class name.   They can be used to compare with the moser object types using <code>getObjectType()</code>.
 */
export default class MoserObjectTypes extends BaseMoserObject{

	static MOSER_OBJECT = "MoserObject";

	static INDEX = "Index";

	static FOREIGN_KEY = "ForeignKey";

	static SECURITY_FILTER = "SecurityFilter";

	static QUERY_SUBJECT = "QuerySubject";

	static RELATIONSHIP = "Relationship";

	static PARAMETER_MAP = "ParameterMap";

	static DRILL_GROUP = "DrillGroup";

	static QUERY_VALUE_SELECTOR = "QueryValueSelector";

	static MODULE = "Module";

	static VALIDATION_MESSAGE = "ValidationMessage";

	static FEEDBACK = "Feedback";

	static ITEM_NORMALIZATION_GROUP_TYPE = "ItemNormalizationGroupType";

	static TEXT_RESOURCE = "TextResource";

	static USE_SPEC = "UseSpec";

	static FACET_TYPE = "FacetType";

	static SORT_LIST_TYPE = "SortListType";

	static ITEM_TYPE = "ItemType";

	static DATA_SOURCE = "DataSource";

	static PHYSICAL_OBJECT_TYPE = "PhysicalObjectType";

	static BASE_OBJECT_TYPE = "BaseObjectType";

	static PROPERTY_TYPE = "PropertyType";

	static JDBC = "Jdbc";

	static TABLE = "Table";

	static COLUMN = "Column";

	static INDEXED_COLUMN = "IndexedColumn";

	static PRIMARY_KEY = "PrimaryKey";

	static FK_COLUMN = "FkColumn";

	static TABLE_ITEM_TYPE = "TableItemType";

	static STORED_PROCEDURE = "StoredProcedure";

	static PROC_PARAMETER_TYPE = "ProcParameterType";

	static DB_FUNCTION = "DbFunction";

	static STRUCT = "Struct";

	static MULTISET = "Multiset";

	static OBJECT_TYPE = "ObjectType";

	static FILTER = "Filter";

	static ITEM_NORMALIZATION_TYPE = "ItemNormalizationType";

	static SECURITY_OBJECT = "SecurityObject";

	static SQL_QUERY_TYPE = "SqlQueryType";

	static QUERY_OPERATION = "QueryOperation";

	static JOIN_OPERATION = "JoinOperation";

	static TIME_GRAIN = "TimeGrain";

	static TIME_ANCHOR = "TimeAnchor";

	static ACTIVE_TIME_GRAIN = "ActiveTimeGrain";

	static COLUMN_DEPENDENCY = "ColumnDependency";

	static QUERY_ITEM = "QueryItem";

	static BASE_QUERY_ITEM_TYPE = "BaseQueryItemType";

	static TAXONOMY_TYPE = "TaxonomyType";

	static SPLIT_TYPE = "SplitType";

	static PROMPT_INFO_TYPE = "PromptInfoType";

	static CALCULATED_MEMBER_TYPE = "CalculatedMemberType";

	static MEMBER_TYPE = "MemberType";

	static TRANSLATION = "Translation";

	static NAMED_SET = "NamedSet";

	static CARDINALITY_TYPE = "CardinalityType";

	static LINK = "Link";

	static PARAMETER_MAP_ENTRY = "ParameterMapEntry";

	static QUERY_ITEM_MAP = "QueryItemMap";

	static CALCULATION = "Calculation";

	static SEGMENT = "Segment";

	static WHAT_IF_MODEL = "WhatIfModel";

	static ITEM_HIERARCHY = "ItemHierarchy";

	static LOCAL_REF_TYPE = "LocalRefType";

	static CUSTOM_SORT = "CustomSort";

	static PARAMETER_VALUE_SET = "ParameterValueSet";

	static PARAMETER_VALUE = "ParameterValue";

	static VALUE_TYPE = "ValueType";

	static PARAMETER_FAULT = "ParameterFault";

	static PARAMETER_CAPABILITIES_TYPE = "ParameterCapabilitiesType";

	static PROMPT = "Prompt";

	static SORT_EXPRESSION = "SortExpression";

	static PARAMETER_FEEDBACK_INFO = "ParameterFeedbackInfo";

	static FOLDER_TYPE = "FolderType";

	static FOCUS = "Focus";

	static ERROR_DATA = "ErrorData";

	static DATA = "Data";

	static MSG = "Msg";

	static SPLIT_RULE = "SplitRule";

	static SPLIT_CONFIG = "SplitConfig";

	static PROJECTED_ITEM_TYPE = "ProjectedItemType";

	static FOLDER_ITEM_TYPE = "FolderItemType";

	static DEF_LINK_TYPE = "DefLinkType";

	static KEY = "Key";

	static ATTRIBUTE = "Attribute";

	static ITEM = "Item";

	static ANCESTORS = "Ancestors";

	static DATA_SOURCE_OVERRIDE = "DataSourceOverride";

	static CONTEXT = "Context";

	static SORT_ITEM = "SortItem";

	static FOLDER = "Folder";


}


// WEBPACK FOOTER //
// ./src/generated/MoserObjectTypes.js